import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import AttributeGroup from "@/modules/vue/components/AttributeGroup.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'NegotiationFields',
  props: {
    entity: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(AttributeGroup, {
        title: _ctx.$t('negotiation_attributes'),
        attributes: [{
          label: _ctx.$t('patience'),
          percentage: __props.entity.patience
        }, {
          label: _ctx.$t('greediness'),
          percentage: __props.entity.greediness
        }, {
          label: _ctx.$t('resentfulness'),
          percentage: __props.entity.resentfulness
        }]
      }, null, 8, ["title", "attributes"]);
    };
  }
});